// extracted by mini-css-extract-plugin
export default {"modal":"TaskForm_modal__7r2x3","modal-content":"TaskForm_modal-content__RE7MU"};